import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: var(--gray-900);
  color: var(--gray-300);
  padding: 4rem 0 2rem;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1320px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 3rem;
  margin-bottom: 3rem;
  align-items: start;
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;





const FooterTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--white);
  margin-bottom: 1.5rem;
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const FooterLink = styled(Link)`
  color: var(--gray-400);
  text-decoration: none;
  transition: color var(--transition-fast) ease-in-out;
  
  &:hover {
    color: var(--white);
  }
`;





const FooterBottom = styled.div`
  border-top: 1px solid var(--gray-800);
  padding-top: 2rem;
  text-align: center;
`;

const Copyright = styled.p`
  color: var(--gray-500);
  margin: 0;
`;

const QRCodeContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
`;

const QRCodeItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const QRCodeImage = styled.div`
  width: 120px;
  height: 120px;
  background-color: var(--white);
  border-radius: var(--border-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  box-shadow: var(--box-shadow-sm);
`;

const QRCodeLabel = styled.p`
  color: var(--gray-400);
  font-size: 0.875rem;
  margin: 0;
  text-align: center;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterGrid>
          <FooterColumn>
            <FooterTitle>解决方案</FooterTitle>
            <FooterLinks>
              <FooterLink to="/solutions?category=通用">通用解决方案</FooterLink>
              <FooterLink to="/solutions?category=行业">行业解决方案</FooterLink>
            </FooterLinks>
          </FooterColumn>
          
          <FooterColumn>
            <FooterTitle>产品中心</FooterTitle>
            <FooterLinks>
              <FooterLink to="/products?category=软件">软件产品</FooterLink>
              <FooterLink to="/products?category=硬件设备">硬件设备</FooterLink>
            </FooterLinks>
          </FooterColumn>
          
          <FooterColumn>
            <FooterTitle>快速链接</FooterTitle>
            <FooterLinks>
              <FooterLink to="/">首页</FooterLink>
              <FooterLink to="/service-support">服务支持</FooterLink>
              <FooterLink to="/contact">关于我们</FooterLink>
              <FooterLink to="/contact#message">给我留言</FooterLink>
            </FooterLinks>
          </FooterColumn>
          
          <FooterColumn>
            <FooterTitle>关注我们</FooterTitle>
            <QRCodeContainer>
              <QRCodeItem>
                <QRCodeImage>
                  <img 
                    src="/images/weixin.jpg" 
                    alt="微信公众号" 
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
                </QRCodeImage>
                <QRCodeLabel>微信公众号</QRCodeLabel>
              </QRCodeItem>
              <QRCodeItem>
                <QRCodeImage>
                  <img 
                    src="/images/qyh.jpg" 
                    alt="微信企业号" 
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
                </QRCodeImage>
                <QRCodeLabel>微信企业号</QRCodeLabel>
              </QRCodeItem>
            </QRCodeContainer>
          </FooterColumn>
        </FooterGrid>
        
        <FooterBottom>
          <Copyright>
            ©2013-{new Date().getFullYear()} 合肥航泰信息技术有限公司 保留所有权利 备案号：<a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">皖ICP备15022948号</a>
          </Copyright>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;